// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import addProductFilters from "@insite/client-framework/Store/Pages/ProductList/Handlers/AddProductFilters";
import removeProductFilters from "@insite/client-framework/Store/Pages/ProductList/Handlers/RemoveProductFilters";
import { getProductListDataViewProperty } from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";
import { FacetModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductListFilterAccordionSectionStyles } from "@insite/content-library/Widgets/ProductList/ProductListFilterAccordionSection";
import loadPickupWarehouses from "@store/Framework/Store/Store/Data/PickupWarehouses/Handlers/LoadPickupWarehouses";
import { getPickupWarehouseDataView } from "@store/Framework/Store/Store/Data/PickupWarehouses/PickupWarehousesSelectors";
import ProductListStoreAvailabilityFiltersAccordionSection from "@store/Library/Widgets/ProductList/ProductListStoreAvailabilityFilterAccordionSection";
import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import React, { FC } from "react";
import { connect, ResolveThunks } from "react-redux";

const enum fields {
    expandByDefault = "expandByDefault",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.expandByDefault]: boolean;
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    brandFacets: getProductListDataViewProperty(state, "brandFacets"),
    attributeTypeFacets: getProductListDataViewProperty(state, "attributeTypeFacets"),
    pageBrandId: state.pages.productList.productFilters.pageBrandId,
    productFilters: state.pages.productList.productFilters,
    pickUpWarehouse: state.context.session.pickUpWarehouse,
    pickupWarehouseDataView: getPickupWarehouseDataView(state, {
        name: state.context.session.pickUpWarehouse?.name || "Default",
    }),
    isCategoryPage: state.pages.productList.productFilters.pageCategoryId !== undefined,
    filterCategoryId: state.pages.productList.productFilters.categoryId,
    attributeValueIds: state.pages.productList.productFilters.attributeValueIds,
});

const mapDispatchToProps = {
    addProductFilters,
    removeProductFilters,
    loadPickupWarehouses,
};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & OwnProps;

export const productListStoreAvailabilityFiltersStyles: ProductListFilterAccordionSectionStyles = {};

const ProductListStoreAvailabilityFilters: FC<Props> = ({
    attributeTypeFacets,
    addProductFilters,
    removeProductFilters,
    fields,
    pickUpWarehouse,
    loadPickupWarehouses,
    pickupWarehouseDataView,
    isCategoryPage,
    filterCategoryId,
    attributeValueIds,
}) => {
    React.useEffect(() => {
        if (!pickupWarehouseDataView.value && !pickupWarehouseDataView.isLoading) {
            loadPickupWarehouses({ name: pickUpWarehouse?.name || "Default" });
        }
    });
    const trackSearchFiltered = ga.use.trackSearchFiltered();

    const availabilityAttributeTypeFacet = attributeTypeFacets?.find(at => {
        return at.name === "Availability";
    });
    const warehouseAvailabilityAttributeTypeFacet = attributeTypeFacets?.find(at => {
        return at.name === "Warehouse Availability";
    });

    // TODO ISC-11787 - make showMoreLimit configurable
    const showMoreLimit = 10;

    // Hide everything but categories when doing a search
    if (!isCategoryPage && !filterCategoryId && !attributeValueIds?.length) {
        return null;
    }

    if (
        !pickupWarehouseDataView.value ||
        !pickUpWarehouse ||
        !availabilityAttributeTypeFacet ||
        !availabilityAttributeTypeFacet?.attributeValueFacets?.length
    ) {
        return null;
    }

    const onChangeFacet = (facet: FacetModel) => {
        if (facet.selected) {
            removeProductFilters({ attributeValueIds: [facet.id] });
        } else {
            addProductFilters({ attributeValueIds: [facet.id] });
            trackSearchFiltered({ filter_name: facet.name, filter_type: "Attribute" });
        }
    };

    return (
        <ProductListStoreAvailabilityFiltersAccordionSection
            key={availabilityAttributeTypeFacet?.attributeTypeId}
            title={availabilityAttributeTypeFacet?.nameDisplay}
            facets={availabilityAttributeTypeFacet?.attributeValueFacets?.map<FacetModel>(av => ({
                ...av,
                id: av.attributeValueId,
                name: av.valueDisplay,
            }))}
            warehouseAttributeFacets={warehouseAvailabilityAttributeTypeFacet?.attributeValueFacets?.map<FacetModel>(
                av => ({
                    ...av,
                    id: av.attributeValueId,
                    name: av.valueDisplay,
                }),
            )}
            onChangeFacet={onChangeFacet}
            showMoreLimit={showMoreLimit}
            expandByDefault={fields.expandByDefault}
            extendedStyles={productListStoreAvailabilityFiltersStyles}
            pickUpWarehouse={pickUpWarehouse}
            pickUpWarehouses={pickupWarehouseDataView.value}
        />
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(ProductListStoreAvailabilityFilters),
    definition: {
        group: "Product List",
        displayName: "Store Availability Filters",
        allowedContexts: ["ProductListPage"],
        fieldDefinitions: [
            {
                name: fields.expandByDefault,
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
